import React from "react";
import "./TradeDetailsCard.scss";
import { formatDateInTimeZone, FormatUSD } from "../../../utils/helpers/string";
import { normalizeTradeData } from "../../../utils/helpers/trade";
export const getProfitColor = (profit) => {
  return profit >= 0 ? "#4caf50" : "#f44336";
};
const TradeDetailsCard = ({ trade, maeMfedetails }) => {
  // Consume normalized trade object; normalize defensively if needed
  const normalized = normalizeTradeData(trade) || {};
  const normalizedTrade = {
    tradeId:
      normalized.id || normalized.tradeId || normalized.positionId || "N/A",
    symbol: normalized.symbol || "N/A",
    trade_side: normalized.trade_side || "N/A",
    date: normalized.date || normalized.open_time || null,
    duration: normalized.duration ?? "N/A",
    volume: normalized.volume ?? "N/A",
    profit: normalized.pnl ?? 0,
    pips: normalized.pips ?? "N/A",
    commission: normalized.commission ?? 0,
    swap: normalized.swap ?? 0,
    entryPrice: normalized.entryPrice ?? normalized.open_price ?? "N/A",
    exitPrice: normalized.exitPrice ?? normalized.close_price ?? "N/A",
    stopLoss: normalized.stopLoss ?? "N/A",
    takeProfit: normalized.takeProfit ?? "N/A",
    account_id: normalized.account_id ?? "N/A",
    positionId: normalized.positionId ?? "N/A",
    maePip: maeMfedetails?.mae_pips ?? "N/A",
    maePrice: maeMfedetails?.mae ?? "N/A",
    maeTime: maeMfedetails?.mae_time ?? "N/A",
    mfePip: maeMfedetails?.mfe_pips ?? "N/A",
    mfePrice: maeMfedetails?.mfe ?? "N/A",
    mfeTime: maeMfedetails?.mfe_time ?? "N/A",
  };

  const getTradeSideIcon = (side) => {
    return side === "BUY" || side === 1
      ? "↗️ BUY"
      : side === "SELL" || side === 2
      ? "↘️ Sell"
      : "";
  };

  return (
    <div className="trade-card-info">
      {/* Header/Summary Section */}
      <div className="trade-summary">
        <table className="trade-summary-table">
          <thead>
            <tr>
              <th>Type</th>
              <th>Date</th>
              <th>Volume</th>
              <th>Symbol</th>
              <th>PnL</th>
              {/* <th>Pips</th> */}
              <th>Duration</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                {getTradeSideIcon(normalizedTrade.trade_side)}{" "}
                {/* {normalizedTrade.trade_ side} */}
              </td>
              <td>
                {formatDateInTimeZone(normalized.date, "DD MM YYYY, h:mm:ss a")}
              </td>
              <td>{normalizedTrade.volume}</td>
              <td>{normalizedTrade.symbol}</td>
              <td style={{ color: getProfitColor(normalizedTrade.profit) }}>
                {FormatUSD(normalizedTrade.profit)}
              </td>
              {/* <td style={{ color: getProfitColor(normalizedTrade.profit) }}>
                {normalizedTrade.pips}
              </td> */}
              <td>{normalizedTrade.duration}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="trade-details">
        {/* $ Price Panel */}
        <div className="trade-section">
          <h4>$ Price</h4>
          <p>
            <strong>Type:</strong> {normalizedTrade.trade_side}
          </p>
          <p>
            <strong>Open:</strong> {normalizedTrade.entryPrice}
          </p>
          <p>
            <strong>Close:</strong> {normalizedTrade.exitPrice}
          </p>
        </div>

        {/* Trade Protection Panel */}
        {/* <div className="trade-section">
          <h4>Trade Protection</h4>
          <p>
            <strong>SL:</strong> {normalizedTrade.stopLoss}
          </p>
          <p>
            <strong>SL Pips:</strong> -
          </p>
          <p>
            <strong>TP:</strong> {normalizedTrade.takeProfit}
          </p>
          <p>
            <strong>TP Pips:</strong> -
          </p>
        </div> */}

        {/* Results Panel */}
        <div className="trade-section">
          <h4>✔ Results</h4>
          <p>
            <strong>Gross profit:</strong>{" "}
            <span style={{ color: getProfitColor(normalizedTrade.profit) }}>
              {FormatUSD(normalizedTrade.profit)}
            </span>
          </p>
          <p>
            <strong>Swap:</strong> {FormatUSD(normalizedTrade.swap)}
          </p>
          <p>
            <strong>Comm.:</strong> {FormatUSD(normalizedTrade.commission)}
          </p>
          <p>
            <strong>Net profit:</strong>{" "}
            <span style={{ color: getProfitColor(normalizedTrade.profit) }}>
              {FormatUSD(normalizedTrade.profit)}
            </span>
          </p>
        </div>

        {/* Time Panel */}
        <div className="trade-section">
          <h4>🕛Time</h4>
          <p>
            <strong>Open:</strong>{" "}
            {formatDateInTimeZone(
              normalized.open_time,
              "DD MM YYYY, h:mm:ss a"
            )}
          </p>
          <p>
            <strong>Closed:</strong>{" "}
            {formatDateInTimeZone(
              normalized.close_time,
              "DD MM YYYY, h:mm:ss a"
            )}
          </p>
        </div>

        {/* Trade Stats Panel */}
        <div className="trade-section">
          <h4>📈 Trade Stats ⓘ</h4>
          <p>
            <strong>MAE Pip:</strong>{" "}
            {Number(normalizedTrade.maePip).toFixed(2)}
          </p>
          <p>
            <strong>MAE:</strong> {FormatUSD(normalizedTrade.maePrice)}
          </p>
          <p>
            <strong>MAE Time:</strong>{" "}
            {formatDateInTimeZone(
              normalizedTrade.maeTime,
              "DD MM YYYY, h:mm:ss a"
            )}
          </p>
          <p>
            <strong>MFE Pip:</strong>{" "}
            {Number(normalizedTrade.mfePip).toFixed(2)}
          </p>
          <p>
            <strong>MFE:</strong> {FormatUSD(normalizedTrade.mfePrice)}
          </p>
          <p>
            <strong>MFE Time:</strong>
            {formatDateInTimeZone(
              normalizedTrade.maeTime,
              "DD MM YYYY, h:mm:ss a"
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TradeDetailsCard;
